import React from 'react';

import {
  styled,
  Typography
} from '@mui/material';
import imgBackground from 'assets/images/background_legal.png';
import {
  activityTemplates,
  AuthWrapper,
  legalDocumentsDataService,
  ExternalLink,
  LoadingOverlay,
  TextSectionWithStepNumber,
  SectionContainer
} from 'modules';

import * as LawFirmsSection from './components/LawFirmsSection/LawFirmsSection';
import { LegalTerms } from './components/LegalTerms/LegalTerms';
import * as MoveToDocumentSection from './components/MoveToDocumentSection/MoveToDocumentSection';
import * as ProjectTheOutcomeSection from './components/ProjectTheOutcomeSection/ProjectTheOutcomeSection';
import * as TermSheetSection from './components/TermSheetSection/TermSheetSection';



const TitleTypography = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(3)
}));

const DescriptionTypography = styled(Typography)(({ theme }) => ({
  maxWidth: 840,
  color: '#FFFFFF',
  fontSize: 20,
  textAlign: 'center'
}));



export const LegalActivity: React.FC = () => {
  const { data, loading } = legalDocumentsDataService.useLegalDocuments();



  return (
    <AuthWrapper.FC>
      <activityTemplates.BaseActivityTemplate.FC
        imgBackground={imgBackground}
        colorVariant="dark"
        backgroundSize="contain"
        doNotWrapChildrenInContainer>
        <LoadingOverlay active={loading} />



        <SectionContainer.FC
          marginTop="calc(100vw * 0.15 - 112px)"
          marginBottom="calc(100vw * 0.25 - 112px)">
          <TitleTypography
            variant="h1"
            color="#FFFFFF">
          Legal Process
          </TitleTypography>

          <DescriptionTypography>
          Prepare for the legal journey - check out standard legal documents, explanations of terms, and our scenario modeling spreadsheets.
          </DescriptionTypography>
        </SectionContainer.FC>



        <TextSectionWithStepNumber.FC
          step="1"
          title="Receive your term sheet"
          subtitle={
            <Typography>
              Check out the more standard term sheets or instruments you may see - Equity, Convertible Debt, and SAFE Note. For thoughts on the pros and cons of each instrument, check out our blog post&nbsp;
              <ExternalLink.Text href="https://www.raisewithridge.com/post/2022/04/20/equity-vs-convertible-vs-safe">here</ExternalLink.Text>
              .
            </Typography>
          }>
          <SectionContainer.FC marginBottom={135}>
            <TermSheetSection.FC apiFileData={data.termSheets} />
          </SectionContainer.FC>
        </TextSectionWithStepNumber.FC>



        <TextSectionWithStepNumber.FC
          background='linear-gradient(180deg, rgba(240, 247, 250, 0) 0%, #F0F7FA 31.1%, rgba(240, 247, 250, 0) 91.16%);'
          step="2"
          title="Review terms alongside counsel"
          subtitle="If you received a term sheet tomorrow, would you be ready to negotiate it? We have identified key terms and implications for your company." >
          <SectionContainer.FC>
            <LegalTerms />
          </SectionContainer.FC>
        </TextSectionWithStepNumber.FC>



        <SectionContainer.FC>
          <LawFirmsSection.FC />
        </SectionContainer.FC>



        <SectionContainer.FC>
          <TextSectionWithStepNumber.FC
            step="3"
            title="Project the outcome"
            subtitle="Model out the financing scenario with our Excel spreadsheets - both what the cap table could look like following the raise and what your proceeds could look like in an exit scenario thereafter." >
            <ProjectTheOutcomeSection.FC apiFileData={data.proFormaTable}/>
          </TextSectionWithStepNumber.FC>
        </SectionContainer.FC>



        <SectionContainer.FC
          marginTop={140}
          marginBottom={100}>
          <TextSectionWithStepNumber.FC
            step="4"
            title="Move to documents"
            subtitle={
              <Typography>
                There are a lot of longer legal documents to review, with significant implications to company ownership and controls. Check out these NVCA templates. Also, to visit the NVCA's site, click&nbsp;
                <ExternalLink.Text href="https://nvca.org/model-legal-documents/">here</ExternalLink.Text>
              .
              </Typography>
            }>
            <MoveToDocumentSection.FC apiFileData={data.legalDocuments}/>
          </TextSectionWithStepNumber.FC>
        </SectionContainer.FC>

      </activityTemplates.BaseActivityTemplate.FC>
    </AuthWrapper.FC>
  );
};
